import { signIn, signInWithMagicLink, signOut, signUp } from "./auth.js";
export function createAuthApi(supabase, options = {}) {
    const { magicLinkRedirectTo } = options;
    return {
        signInWithPassword: (email, password) => signIn(supabase, { email, password }),
        signUpWithPassword: (email, password) => signUp(supabase, { email, password }),
        sendMagicLink: (email, emailRedirectTo) => signInWithMagicLink(supabase, {
            email,
            emailRedirectTo: emailRedirectTo ?? magicLinkRedirectTo,
        }),
        signOutUser: () => signOut(supabase),
    };
}
